import { T } from '@transifex/react'
import React, { FunctionComponent } from 'react'
import { PaymentInfoBanner } from './PaymentInfoBanner'

/**
 * Banner shown above the payment input when the active outlet has an LSPay
 * cash discount configured. Explains that the discount requires paying the
 * full balance in a single cash payment.
 */
export const LspCashDiscountFullPaymentBanner: FunctionComponent = () => {
  return (
    <PaymentInfoBanner
      message={
        <T
          _str="To offer cash discount, the full balance must be paid in a single cash payment."
          _context="LSPay cash discounting full payment banner"
        />
      }
    />
  )
}
